const locale_en = {
    bandContent: 'Content',
    bandFooter: 'Footer',
    bandHeader: 'Header',
    clear: 'Clear',
    contentHeight: 'Content height',
    contentHeightInfo: 'affects only GUI size to place elements and not the real page size',
    differentFiles: 'different files...',
    differentValues: 'different values...',
    docElementAlignToPageBottom: 'Align to bottom of page',
    docElementAlternateBackgroundColor: 'Alternate background color',
    docElementAlwaysPrintOnSamePage: 'Always on same page',
    docElementBarCode: 'Bar code',
    docElementBarWidth: 'Bar width',
    docElementBorderFrame: 'Frame',
    docElementBorderFrameRow: 'Frame and row',
    docElementBorderGrid: 'Grid',
    docElementBorderNone: 'None',
    docElementBorderRow: 'Row',
    docElementColor: 'Color',
    docElementColspan: 'Colspan',
    docElementColumns: 'Columns',
    docElementConditionalStyle: 'Conditional style',
    docElementConditionalStyleCondition: 'Condition',
    docElementContent: 'Text',
    docElementContentRows: 'Content rows',
    docElementDataSource: 'Data source',
    docElementDisplayValue: 'Display value',
    docElementErrorCorrectionLevel: 'Error correction',
    docElementErrorCorrectionLevelHigh: 'High',
    docElementErrorCorrectionLevelLow: 'Low',
    docElementErrorCorrectionLevelMedium: 'Medium',
    docElementErrorCorrectionLevelQuartile: 'Quartile',
    docElementEval: 'Evaluate',
    docElementFormat: 'Format',
    docElementFrame: 'Frame',
    docElementGroupExpression: 'Group expression',
    docElementGrowWeight: 'Grow weight',
    docElementGrowWeightInfo: 'Grow factor to take space of hidden columns',
    docElementGrowWeightHigh: 'high',
    docElementGrowWeightLow: 'low',
    docElementGuardBar: 'Guard bars',
    docElementHeight: 'Height',
    docElementImage: 'Image',
    docElementImageFile: 'Image file',
    docElementLabel: 'Label',
    docElementLine: 'Line',
    docElementLink: 'Link',
    docElementLoadImageErrorMsg: 'Loading image failed',
    docElementPageBreak: 'Page break',
    docElementPattern: 'Pattern',
    docElementPosition: 'Position (x, y)',
    docElementPositionX: 'Position (x)',
    docElementPositionY: 'Position (y)',
    docElementPrintIf: 'Print if',
    docElementPrintSettings: 'Print settings',
    docElementRemoveEmptyElement: 'Remove when empty',
    docElementRepeatGroupHeader: 'Repeat group on each page',
    docElementRepeatHeader: 'Repeat header',
    docElementRichText: 'Rich text',
    docElementRoot: 'Document',
    docElementRotate: 'Rotate',
    docElementSection: 'Section',
    docElementShrinkToContentHeight: 'Shrink to content height',
    docElementSize: 'Size (width, height)',
    docElementSource: 'Source',
    docElementSpreadsheet: 'Spreadsheet',
    docElementSpreadsheetAddEmptyRow: 'Add empty row below',
    docElementSpreadsheetColspan: 'Colspan',
    docElementSpreadsheetColumn: 'Fixed column',
    docElementSpreadsheetHide: 'Hide',
    docElementSpreadsheetTextWrap: 'Text wrap',
    docElementStyle: 'Style',
    docElementTable: 'Table',
    docElementTableBandPageBreak: 'Page break with each new group',
    docElementText: 'Text',
    docElementWidth: 'Width',
    documentProperties: 'Document properties',
    documentTabClose: 'Close',
    documentTabPdfLayout: 'PDF Layout',
    documentTabPdfPreview: 'PDF Preview',
    documentTabXlsxDownload: 'XLSX Download',
    emptyPanel: 'Empty panel',
    errorMsgDuplicateParameter: 'Parameter already exists',
    errorMsgDuplicateParameterField: 'Field already exists',
    errorMsgFontNotAvailable: 'Font not available on server',
    errorMsgLoadingImageFailed: 'Loading image failed: ${info}',
    errorMsgInvalidArray: 'Invalid list',
    errorMsgInvalidAvgSumExpression: 'Expression must contain number field of a list parameter',
    errorMsgInvalidBarCode: 'Invalid bar code content',
    errorMsgInvalidDataSource: 'Invalid data source',
    errorMsgInvalidDataSourceParameter: 'Parameter must be a list',
    errorMsgInvalidDate: 'Invalid date, expected format is YYYY-MM-DD (or YYYY-MM-DD hh:mm for date with time)',
    errorMsgInvalidStringData: 'Invalid data for text parameter ${info}',
    errorMsgInvalidExpression: 'Invalid expression: ${info}',
    errorMsgInvalidExpressionFuncNotDefined: 'Function ${info} not defined',
    errorMsgInvalidExpressionNameNotDefined: 'Name ${info} not defined',
    errorMsgInvalidExpressionType: 'Expression returns invalid type',
    errorMsgInvalidLink: 'Link must start with http:// or https://',
    errorMsgInvalidImage: 'Invalid image data, image must be base64 encoded',
    errorMsgInvalidImageSource: 'Invalid source, expected url starting with http:// or https:// respectively',
    errorMsgInvalidImageSourceParameter: 'Parameter must be an image or string (containing a url)',
    errorMsgInvalidMap: 'Invalid collection',
    errorMsgInvalidNumber: 'Invalid number',
    errorMsgInvalidPageSize: 'Invalid page size',
    errorMsgInvalidParameterData: 'Data does not match parameter',
    errorMsgInvalidParameterName: 'Name must start with a character or underscore, and must only contain characters, digits and underscores (_)',
    errorMsgInvalidPattern: 'Invalid pattern',
    errorMsgInvalidPosition: 'The position is outside the area',
    errorMsgInvalidSize: 'The element is outside the area',
    errorMsgInvalidTestData: 'Invalid test data',
    errorMsgMissingData: 'Missing data',
    errorMsgMissingDataSourceParameter: 'Data source parameter not found',
    errorMsgMissingExpression: 'Expression must be set',
    errorMsgMissingImage: 'Missing image, no source or image file specified',
    errorMsgMissingParameter: 'Parameter not found',
    errorMsgMissingParameterData: 'Data for parameter {info} not found',
    errorMsgRepeatGroupHeaderAfterContent: 'Not allowed for group after content row',
    errorMsgPlusVersionRequired: 'Requires commerical PLUS version',
    errorMsgSectionBandNotOnSamePage: 'Section band does not fit on same page',
    errorMsgSectionBandPageBreakNotAllowed: 'Manual page break not allowed',
    errorMsgUnicodeEncodeError: 'Text contains non printable character',
    errorMsgUnsupportedImageType: 'Image does not have supported image type (.jpg, .png)',
    footer: 'Footer',
    footerDisplay: 'Display',
    footerSize: 'Footer size',
    header: 'Header',
    headerDisplay: 'Display',
    headerFooterDisplayAlways: 'Always',
    headerFooterDisplayNotOnFirstPage: 'Do not show on first page',
    headerSize: 'Header size',
    menuColumnAddLeft: 'Add column to the left',
    menuColumnAddRight: 'Add column to the right',
    menuColumnDelete: 'Delete column',
    menuAlignBottom: 'Align bottom',
    menuAlignCenter: 'Align center',
    menuAlignLeft: 'Align left',
    menuAlignMiddle: 'Align middle',
    menuAlignRight: 'Align right',
    menuAlignTop: 'Align top',
    menuInsertReport: 'INSERT',
    menuInsertReportTip: 'Insert report template',
    menuLogReport: 'LOG',
    menuLogReportTip: 'Log report template to console',
    menuPreview: 'PREVIEW',
    menuPreviewTip: 'Preview report',
    menuRedo: 'REDO',
    menuRedoTip: 'Repeat last undone command',
    menuRowAddAbove: 'Add row above',
    menuRowAddBelow: 'Add row below',
    menuRowDelete: 'Delete row',
    menuSave: 'SAVE',
    menuSaveTip: 'Save report',
    menuToggleGrid: 'Show/Hide grid',
    menuUndo: 'UNDO',
    menuUndoTip: 'Undo last command',
    menuZoomIn: 'Zoom in',
    menuZoomOut: 'Zoom out',
    nameCopySuffix: 'copy',
    orientation: 'Orientation',
    orientationBottom: 'bottom',
    orientationLandscape: 'Landscape',
    orientationLeft: 'left',
    orientationPortrait: 'Portrait',
    orientationRight: 'right',
    orientationTop: 'top',
    pageFormat: 'Page format',
    pageFormatA4: 'DIN A4 (210 x 297 mm)',
    pageFormatA5: 'DIN A5 (148 x 210 mm)',
    pageFormatLetter: 'Letter (8.5 x 11.0 inches)',
    pageFormatUserDefined: 'Own dimensions',
    pageHeight: 'height',
    pageMargins: 'Page margins',
    pageWidth: 'width',
    parameter: 'Parameter',
    parameterAddTestData: 'Add row',
    parameterArrayItemType: 'List item type',
    parameterEditTestData: 'Edit',
    parameterEditTestDataNoFields: 'No fields defined for this list',
    parameterEval: 'Evaluate text',
    parameterExpression: 'Expression',
    parameterListType: 'List type',
    parameterName: 'Name',
    parameterNullable: 'Nullable',
    parameterPattern: 'Pattern',
    parameterRowParams: 'Row parameters',
    parameterSearchPlaceholder: 'Search parameters...',
    parameterTestData: 'Test data',
    parameterTestDataDatePattern: 'YYYY-MM-DD',
    parameterTestDataImageInfo: 'Images are saved in the report template and could significantly increase report template size',
    parameterTestDataRowCount: '${count} rows',
    parameterTestDataRowCountEmpty: 'empty',
    parameterTestDataRowCountOne: '1 row',
    parameterType: 'Type',
    parameterTypeArray: 'List',
    parameterTypeAverage: 'Average',
    parameterTypeBoolean: 'Boolean',
    parameterTypeDate: 'Date',
    parameterTypeImage: 'Image',
    parameterTypeMap: 'Collection',
    parameterTypeNumber: 'Number',
    parameterTypeSimpleArray: 'Simple List',
    parameterTypeString: 'Text',
    parameterTypeSum: 'Sum',
    parameters: 'Parameters',
    parametersDataSource: 'Data source parameters',
    patternCurrencySymbol: 'Pattern currency symbol',
    patternDate1: 'day.month.year, e.g. 1.6.1980',
    patternDate2: 'day.month.year (2-digit), hour(24h):minute, e.g. 1.6.80, 14:30',
    patternDate3: 'day/month/year (month abbreviation), e.g. 1/Jun/1980',
    patternDate4: 'month/day/year (day and month with leading zero if single digit), e.g. 06/01/1980',
    patternLocale: 'Pattern locale',
    patternNumber1: 'Show thousand separator',
    patternNumber2: 'Show decimal point followed by 3 decimal places',
    patternNumber3: 'Show decimal point followed by minimum of 2 and maximum of 4 decimal places',
    patternNumber4: 'Show thousand separator and decimal point followed by 2 decimal places',
    patternNumber5: 'Show currency symbol in front of number',
    patternNumberGroupSymbol: 'Thousands separator',
    patternNumberGroupSymbolInfo: 'leave empty for default',
    patternSeparatorDates: '--- Date patterns ---',
    patternSeparatorNumbers: '--- Number patterns ---',
    plusFeatureInfo: 'Requires commerical <a href="https://www.reportbro.com/license/index" target="_blank" rel="noreferrer">PLUS version</a>',
    plusFeatureInfoNestedParameter: 'Nested parameter requires commerical <a href="https://www.reportbro.com/license/index" target="_blank" rel="noreferrer">PLUS version</a>',
    select: 'select...',
    style: 'Style',
    styleAlignment: 'Alignment',
    styleBackgroundColor: 'Background color',
    styleBold: 'Bold',
    styleBorder: 'Border',
    styleBorderAll: 'borders',
    styleBorderColor: 'Border color',
    styleBorderWidth: 'Border width',
    styleFont: 'Font',
    styleFontSizeUnit: 'pt',
    styleHAlignmentCenter: 'Center',
    styleHAlignmentLeft: 'Left',
    styleHAlignmentJustify: 'Justify',
    styleHAlignmentRight: 'Right',
    styleItalic: 'Italic',
    styleLineSpacing: 'Line spacing',
    styleName: 'Name',
    styleNone: 'None',
    stylePadding: 'Padding',
    styleStrikethrough: 'Strikethrough',
    styleTextColor: 'Text color',
    styleTextStyle: 'Text style',
    styleUnderline: 'Underline',
    styleVAlignmentBottom: 'Bottom',
    styleVAlignmentMiddle: 'Middle',
    styleVAlignmentTop: 'Top',
    styles: 'Styles'
};

export default locale_en;
